import fetchDataFromSpreadsheet from "./fetchDataFromSpreadsheet";

async function getCompanyData(client) {
  const rows = await fetchDataFromSpreadsheet(client);

  return rows.map((row, index) => {
    return {
      companyID: index,
      companyName: row['name']?.trim() || "",
      companysCountry: row['country']?.trim() || "",
      sector: row['sector']?.trim() || "",
      IRwebsiteLink: row['website']?.trim() || "",
      symbol: row['symbol']?.trim() || "",
      annualReportLink: row['annual_report']?.trim() || "",
      stockPrice: row['stock_price']?.trim() || "",
      stockPriceDelta: row['stock_price_delta']?.trim() || "",
    }
  });
}

export default getCompanyData;
